import AsyncFlow from '../asyncFlow';

export default AsyncFlow({
    store: 'set-moduli',
    initialState: {
        isInserted: '',
        statusAction: 'READY',
    },
    actions: ['SET_CODICE_MODULI'],
}).extend({
    reducer: (state, action, { types }) => {
        switch (action.type) {
            case types.SET_CODICE_MODULI_SUCCESS:
                return {
                    ...state,
                    isInserted: action.payload.isInserted
                };
            default:
                return state;
        }
    },
    creators: ({ types }) => ({
        setCodiceModuliRequest: (pk, IDModulo, dataDecorr, codiceUtente, tipologia, sn, moduli) => ({
            type: types.SET_CODICE_MODULI_REQUEST,
            payload: { pk, IDModulo, dataDecorr, codiceUtente, tipologia, sn, moduli },
        }),
        setCodiceModuliSuccess: ({ isInserted }) => ({
            type: types.SET_CODICE_MODULI_SUCCESS,
            payload: { isInserted },
        }),
        setCodiceModuliFailed: error => ({ type: types.SET_CODICE_MODULI_FAILED, error: true, payload: { error } }),
    }),
});
